export class ChangePasswordModel {
    userId: any;
    password: any;
}
